import { ProfileView } from '../features/profile/ProfileView.tsx'
import { IntlProvider } from 'react-intl'
import {
  getIntlMessages,
  resolveIntlLocale,
} from '../shared/translations/messages.ts'
import { useOnboardingData } from '../features/onboarding/onboardingData.ts'
import { useSnapshot } from 'valtio/react'
import { useAppModule } from '../features/appContext.ts'

export function ProfilePage() {
  const appModule = useAppModule()
  const state = useSnapshot(appModule.appStore.state)
  const onboardingData = useOnboardingData()
  const locale = resolveIntlLocale(String(state.language))

  return (
    <IntlProvider
      locale={locale}
      defaultLocale="en"
      messages={getIntlMessages(locale)}
    >
      <ProfileView onboardingData={onboardingData} />
    </IntlProvider>
  )
}
